/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonInviteReply,
    JsonInviteReplyFromJSON,
    JsonInviteReplyFromJSONTyped,
    JsonInviteReplyToJSON,
} from './JsonInviteReply';

/**
 * 
 * @export
 * @interface ApiResultOfJsonInviteReply
 */
export interface ApiResultOfJsonInviteReply {
    /**
     * 
     * @type {JsonInviteReply}
     * @memberof ApiResultOfJsonInviteReply
     */
    data?: JsonInviteReply;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReply
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonInviteReply
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReply
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReply
     */
    result?: ApiResultOfJsonInviteReplyResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonInviteReplyResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonInviteReplyFromJSON(json: any): ApiResultOfJsonInviteReply {
    return ApiResultOfJsonInviteReplyFromJSONTyped(json, false);
}

export function ApiResultOfJsonInviteReplyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonInviteReply {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonInviteReplyFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonInviteReplyToJSON(value?: ApiResultOfJsonInviteReply | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonInviteReplyToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

